export default function (value, constantKey) {
    const constants = window.Globals && window.Globals.constants;
    if (!constants) return value;

    const item = constants[constantKey].find((c) => c.id === value) || {};

    return item.name || value;
}
